(function() {

  function setCookie(name,value,days) {
      var expires = "";
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }
  function eraseCookie(name) {   
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  
  function moduloPositiveOnly(number, mod) {
    let result = number % mod;
    if (result < 0) {
      result += mod;
    }
    return result;
  }

  function getChildIndex(child) {
    return Array.prototype.indexOf.call(child.parentNode.children, child);
  }
  
  class FAQ {
    constructor(faq) {
      this.faq = faq;
      this.question = faq.querySelector('.faq-question');
      this.slide = faq.querySelector('.slide-animation');
      this.answer = faq.querySelector('.faq-answer');

      this.question.addEventListener('click', this.handleToggle.bind(this));
    }

    handleToggle() {
      this.faq.classList.toggle('open');
      this.slide.style.height = this.slide.offsetHeight === 0 ? this.answer.offsetHeight + 'px' : 0 ;
    }
  }
  
  class Carousel {
    constructor(carousel) {
      this.carousel = carousel;
      this.buttonPrevious = carousel.querySelector('.prev-button');
      this.buttonNext = carousel.querySelector('.next-button');
      this.nav = carousel.querySelector('.nav-dots');
      this.slidesContainer = carousel.querySelector('.slide-list');
      this.currentSlide = 0;
      this.numSlides = this.slidesContainer.children.length;
      this.videos = this.slidesContainer.querySelectorAll('.image-section video');
      if (this.videos.length) {
        this.videos[0].play();
      }

      this.nav.addEventListener('click', this.handleNav.bind(this));
      this.buttonPrevious.addEventListener('click', this.handlePrevious.bind(this));
      this.buttonNext.addEventListener('click', this.handleNext.bind(this));
      let self = this;
      
      this.interval = setInterval(function() {
        // console.log('fire int 1');
        if (!self.slidesContainer.children[self.currentSlide].matches(':hover')) {
          self.handleNext();
        }
      }, 4000);
    }

    changeSlide() {
      this.slidesContainer.style.setProperty('--current-slide', this.currentSlide);
      [...this.nav.children].forEach(navLink => navLink.classList.remove('active'));
      this.nav.children[this.currentSlide].classList.add('active');

      this.videos.forEach(video => video.pause());
      let video = this.slidesContainer.children[this.currentSlide].querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.play();
      }

      let self = this;
      clearInterval(this.interval);
      this.interval = setInterval(function() {
        // console.log('int 2 fire');
        if (!self.slidesContainer.children[self.currentSlide].matches(':hover')) {
          self.handleNext();
        }
      }, 4000);
    }
    
    handleNext(e) {
      if (e) {e.preventDefault()};
      this.currentSlide = moduloPositiveOnly(this.currentSlide + 1, this.numSlides);
      this.changeSlide();
    }
  
    handlePrevious(e) {
      e.preventDefault();
      this.currentSlide = moduloPositiveOnly(this.currentSlide - 1, this.numSlides);
      this.changeSlide();
    }

    handleNav(e) {
      if ([...e.target.classList].indexOf('nav-dots') === -1) {
        this.currentSlide = getChildIndex(e.target);
        this.changeSlide();
      }
    }
  }

  const faqs = document.querySelectorAll('.faq-container');
  faqs.forEach(faqElement => new FAQ(faqElement));
  
  const carousels = document.querySelectorAll('.carousel');
  carousels.forEach(carouselElement => new Carousel(carouselElement));

  function adjustPlanData(e) {
    const planData = {
      "Standard_req": {
        "price": "$3,997<span class='per-month'>/month</span>",
        "savings": "",
        "request": "One request",
        "days": "30 days"
      },
      "Pro_req": {
        "price": "$5,997<span class='per-month'>/month</span>",
        "savings": "Save $1,000",
        "request": "Two requests",
        "days": "30 days"
      }
    }

    const chosenRequest = document.getElementById('request-amount').checked ? "Pro" : "Standard";
    const buttonSelector = `.button.request-${chosenRequest}`;
    const chosenPlan = planData[`${chosenRequest}_req`];
    
    document.querySelector('.plan-price .toggle-price').innerHTML = chosenPlan.price;
    document.querySelector('.plan-price .badge').innerHTML = chosenPlan.savings;
    document.querySelector('.plan-tagline .request').innerHTML = chosenPlan.request;
    document.querySelector('.included-list .request').innerHTML = chosenPlan.request;
    
    document.querySelectorAll('.plan .plan-frequency ~ .button').forEach(el => el.style.display = "none");
    document.querySelector(buttonSelector).style.display = "inline-block";
  }

  function scrollWithOffset(params) {
    const yOffset = document.getElementById('shopify-section-header').offsetHeight * -1;
    const element = document.querySelector(params);
    
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    
    window.scrollTo({top: y, behavior: 'smooth'});
  }
  
  function samePageLink(e) {
    if (e.target.classList.contains('same-page-link')) {
      e.preventDefault();
      let linkedElement = e.target.attributes.href.value;
      if (visualViewport.width <= 850) {
        scrollWithOffset(linkedElement);
      } else {
        document.querySelector(linkedElement).scrollIntoView({ behavior: "smooth" });
      }
    }
  }

  document.querySelectorAll('.choice .plan-input').forEach(el => el.addEventListener('input', adjustPlanData));
  document.addEventListener('click', samePageLink);
  document.querySelectorAll('.same-page-link').forEach(el => el.addEventListener('click', samePageLink));
  
  // modal events
  function modalTrigger(e) {
    console.log('modalTrigger', e.currentTarget, e.target.classList.contains('modal-trigger'));
    e.preventDefault();
    e.stopPropagation();
    let modalName = e.currentTarget.attributes.href.value;
    document.querySelectorAll('.modal-content').forEach(el => el.style.display = "none");
    document.querySelector(modalName).style.display = "block";
    document.getElementById('modal-container').classList.add('active');
  }

  document.querySelectorAll('.modal-trigger').forEach(el => el.addEventListener('click', modalTrigger));
  document.querySelectorAll('.drawer-toggle').forEach(el => el.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    document.querySelector('#navigation').classList.toggle('mobile-active');
  }));
  // Close the mobile menu when clicking outside of the #navigation div
    $(document).on('click', function(event) {
        if (!$(event.target).closest('#navigation').length) {
            $('#navigation').removeClass('mobile-active'); // Remove the class from body or appropriate element
        }
    });

  document.querySelectorAll('.add-ons-trigger').forEach(el => el.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    document.querySelector('#plans .add-ons').classList.toggle('active');
    if (!document.querySelector('#plans .add-ons').classList.contains('active')) {
      document.querySelector('#modal-container').classList.remove('active');
    }
  }));

  // global close modals
  document.addEventListener('click', (e) => {
    if (!document.querySelector('#modal-container').classList.contains('active')) {
      document.querySelector('#plans .add-ons').classList.remove('active');
    }
    document.querySelector('#modal-container').classList.remove('active');
    document.querySelector('#navigation').classList.remove('mobile-active');
    // document.querySelector('#newsletter-modal').classList.remove('active');
  });
  document.querySelectorAll('.close').forEach(el => el.addEventListener('click', (e) => {
    document.querySelector('#modal-container').classList.remove('active');
    document.querySelector('#navigation').classList.remove('mobile-active');
    document.querySelector('#newsletter-modal').classList.remove('active');
    if (e.target.parentElement.id === "newsletter-modal" && getCookie('promo') !== "signed_up") {
      setCookie('promo', 'seen');
    }
  }));

  // Stop Propagation for modals
  // document.querySelector('#plans .add-ons').addEventListener('click', (e) => {
  //   if (visualViewport.width <= 900) {
  //     e.stopPropagation();
  //   }
  // });
  document.querySelector('#modal-container').addEventListener('click', (e) => {
    e.stopPropagation();
  });
  document.querySelector('#navigation').addEventListener('click', (e) => {
    e.stopPropagation();
  });
  document.querySelector('#newsletter-modal').addEventListener('click', (e) => {
    e.stopPropagation();
  });

  if (window.location.href.indexOf('customer_posted=true') > -1) {
    document.getElementById('newsletter-modal').style.transition = 'none';
    document.getElementById('newsletter-modal').classList.add('active');
    setTimeout(() => document.getElementById('newsletter-modal').style.transition = 'transform .4s', 100);
    setCookie('promo', 'signed_up', 400);
    // setTimeout(() => document.getElementById('newsletter-modal').classList.remove('active'), 5000);
  } else {
    setTimeout(function () {
      if (getCookie('promo') !== "seen" && getCookie('promo') !== "signed_up" && window.location.href.indexOf('/challenge') === -1) {
        document.querySelector('#newsletter-modal').classList.add('active');
      }
    }, 3000);
  }

  document.getElementById('contact_form').addEventListener('submit', (e) => {
    console.log(e);
    e.preventDefault();

    if (e.target.querySelector('#name-here').value.length) {
      console.log("Bot detected");
      return false;
    }

    const form = document.getElementById('contact_form');
    const params = new FormData(form);
    const request = new XMLHttpRequest();
    request.open("POST", "/contact#contact_form");
    request.onreadystatechange = (e) => {
      if (request.readyState === 4) {
        if (request.responseURL === "https://optimizers.studio/challenge") {
          window.location.href = "https://optimizers.studio/challenge";
        } else {
          console.log('test', request, request.readyState);
          let newH3 = document.createElement('h3');
          let newSpan = document.createElement('span');
          newH3.innerHTML = "Thanks for signing up! Here's your 5% off discount code: ";
          newH3.classList.add('section-title');
          newSpan.innerHTML = "DKTHBDPM";
          newH3.append(newSpan);
          document.getElementById('newsletter-modal').prepend(newH3);
          setCookie('promo', 'signed_up', 400);
        }
      }
    };
    document.getElementById('contact_form');request.send(params);
  });

  document.addEventListener('scroll', (e) => {
    if (window.visualViewport.pageTop < 30) {
      document.getElementById('shopify-section-header').classList.remove('scroll');
    } else {
      document.getElementById('shopify-section-header').classList.add('scroll');
    }

    let nav = document.getElementById('navigation');
    let activeValue = visualViewport.height / 4;
    [...nav.children].filter(child => child.classList.contains('same-page-link')).forEach((link) => {
      let section = document.querySelector(link.attributes.href.value);
      let position = section.getBoundingClientRect();
      if (position.top < activeValue && position.bottom > activeValue) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
    
  });
  
})();

































